<template>
  <a-descriptions :column='1'>
      <a-descriptions-item label="创建人">{{orderData.create_role_name}}</a-descriptions-item>
    <a-descriptions-item label="退货单号">{{orderData.refund_warehousing_sn}}</a-descriptions-item>
    <a-descriptions-item label="退回仓库" v-if="type == 'list'">{{orderData.refund_warehouse_name}}</a-descriptions-item>
    <a-descriptions-item :label="type == 'channel'?'创建人':'退货人'">{{orderData.to}}</a-descriptions-item>
    <a-descriptions-item label="创建时间">{{orderData.create_time}}</a-descriptions-item>
    <a-descriptions-item label="备注">{{orderData.remark || '-'}}</a-descriptions-item>
  </a-descriptions>
</template>
<script>
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import { getRefundOrderMore } from "@/api/antiFleeing";
  export default {
    components: {},
    props: {
      id: {
        type: String||Number
      },
      type:{
        type: String
      }
    },
    setup(props) {
      const state = reactive({
        orderData:{},
      })
      const $route = inject("$route");
      //获取详情
      const getMore = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getRefundOrderMore(props.id ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          state.orderData = res.data;
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      onMounted(() => {
        getMore();
      });
      return {
        ...toRefs(state),
      };
    },
  };
</script>